import React, { Component } from "react";

import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
  CInput
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

import "../../scss/style2.scss";

const FileDownload = require("js-file-download");

class CorrectUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      upload: null,
      grade: null
    };
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    let obj = {
      upload_id: this.props.id,
      user_id: this.props.user_id,
      item_id: this.props.item_id,
      execution_id: this.props.execution_id
    };

    axios
      .get(`${URL.api}content/upload_user/list`, {
        params: obj,
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          upload: resp.data.data,
          grade: resp.data.data.execution.final_grade,
          loading: false
        });
      });
  }

  save() {
    let obj = {
      execution_id: this.props.execution_id,
      item_id: this.props.item_id,
      final_grade: this.state.grade
    };

    axios
      .post(`${URL.api}activity/execution/item/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.onClose();
      });
  }

  download(url, filename) {
    window.open(url, "_blank");
    /* axios.get(URL.api + 'download/' + url.replace(URL.img + "uploads/", ""), {headers: {'authorization': 'Bearer ' + this.props.user.token},
      responseType: 'blob',
    }).then(res => {
      FileDownload(res.data, filename);
    }); */
  }

  render() {
    if (this.state.loading) {
      return (
        <CModal
          onClose={this.props.onClose}
          show={this.props.show}
          centered
          size="md"
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Correção dos uploads</CModalTitle>
          </CModalHeader>
          <CModalBody
            className="p-4 d-flex align-items-center justify-content-center"
            style={{ overflow: "auto" }}
          >
            <Loading />
          </CModalBody>
        </CModal>
      );
    }

    return (
      <CModal
        onClose={this.props.onClose}
        show={this.props.show}
        centered
        size="md"
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Correção dos uploads</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="mb-3">
            <strong>Descrição</strong>
            <div>{this.state.upload.description}</div>
          </div>
          <section>
            <aside className="mt-3">
              <strong>Arquivos selecionados</strong>
              <ul
                className="list-group mt-2"
                style={{ maxHeight: "10rem", overflow: "auto" }}
              >
                {this.state.upload.users.map(file => (
                  <li
                    key={file.link}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <div className="d-flex align-items-center">
                      <i className="fa fa-file mr-3 text-dark"></i>
                      {file.name}
                    </div>
                    <CButton
                      size="sm"
                      color="primary"
                      onClick={() => this.download(file.link, file.name)}
                    >
                      <i className="fa fa-cloud-download"></i>
                    </CButton>
                  </li>
                ))}
              </ul>
            </aside>
          </section>
        </CModalBody>
        <CModalFooter className="justify-content-between">
          <div className="d-flex align-items-center">
            <strong className="mr-2">Nota:</strong>
            <CInput
              type="number"
              min="0"
              max="10"
              step="0.1"
              value={this.state.grade}
              onChange={e => this.setState({ grade: e.target.value })}
            />
          </div>
          <CButton color="primary" onClick={() => this.save()}>
            Salvar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CorrectUpload);
